const UTM_KEYS = ["utm_source", "utm_medium", "utm_campaign"];

export function captureUtm() {
  try {
    const params = new URLSearchParams(window.location.search);
    const found = {};
    UTM_KEYS.forEach((k) => {
      const v = params.get(k);
      if (v) found[k] = v.slice(0, 120);
    });
    if (Object.keys(found).length) {
      sessionStorage.setItem("adika_utm", JSON.stringify(found));
    }
  } catch {
    /* storage unavailable */
  }
}

export function getUtm() {
  try {
    return JSON.parse(sessionStorage.getItem("adika_utm") || "{}");
  } catch {
    return {};
  }
}
